// all in terms of seconds
const SECOND = 1;
const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;
const YEAR = 365 * DAY;
const MONTH = YEAR / 12;

export const TIME = { SECOND, MINUTE, HOUR, DAY, WEEK, MONTH, YEAR };

export const TIME_IN_DAYS = {
    // purposefully not including MONTH, as it's not a fixed number of days and can lead to unexpected results
    DAY: 1,
    WEEK: 7,
    YEAR: 365
};
